// Optimized Sidenav.jsx (updated)
import React, { useEffect, useState, useCallback, useMemo } from "react";
import normalLogo from "../img/logo_next_day.png";
import miniLogo from "../img/ans-app-v3.0.png";
import "./sidenav.css";
import { GoArrowRight } from "react-icons/go";

export default function Sidenav({ location, history }) {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const currentRoute = useMemo(
    () => location.pathname.split("/")[1]?.split("/")[0] || "home",
    [location.pathname]
  );
  const [activeStatus, setActiveStatus] = useState(currentRoute);

  useEffect(() => {
    setActiveStatus(currentRoute);
  }, [currentRoute]);

  const onRouting = useCallback(
    (route, key) => {
      const newActiveKey = key || route?.split("/")[1]?.split("/")[0] || "home";
      setActiveStatus(newActiveKey);
      setIsMobileOpen(false);
      requestAnimationFrame(() => {
        history.push(route || location.pathname);
      });
    },
    [history, location.pathname]
  );

  useEffect(() => {
    if (!isMobileOpen) return;
    const onKey = (e) => e.key === "Escape" && setIsMobileOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isMobileOpen]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileOpen]);

  const NavItem = useCallback(
    ({ route, label, icon, testId }) => {
      const isActive = activeStatus === route;
      return (
        <li className={isActive ? "nav-item active" : "nav-item"}>
          <button
            type="button"
            className={isActive ? "nav-link active" : "nav-link"}
            onClick={() => onRouting(`/${route}`, route)}
            aria-current={isActive ? "page" : undefined}
            data-testid={testId}
          >
            <i
              className="icon"
              data-bs-toggle="tooltip"
              title={label}
              data-bs-placement="right"
            >
              {icon}
            </i>
            <span className="item-name">{label}</span>
          </button>
        </li>
      );
    },
    [activeStatus, onRouting]
  );

  const isNarrow =
    typeof window !== "undefined" ? window.innerWidth < 992 : false;

  return (
    <>
      <button
        type="button"
        className="sidebar-toggle d-lg-none"
        aria-label="Open sidebar"
        aria-expanded={isMobileOpen}
        onClick={() => setIsMobileOpen(true)}
        style={{
          width: "35px",
          height: "35px",
          borderRadius: "50%",
          background: "#fa5f5f",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          transition: "background 0.2s ease",
        }}
      >
        <GoArrowRight size={20} />
      </button>

      {isMobileOpen && (
        <div
          className="sidebar-overlay d-lg-none show"
          role="button"
          aria-label="Close sidebar overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <aside
        className={`sidebar sidebar-base ${isMobileOpen ? "open-mobile" : ""}`}
        id="first-tour"
        data-toggle="main-sidebar"
        data-sidebar="responsive"
        aria-hidden={!isMobileOpen && isNarrow}
      >
        <div className="sidebar-header d-flex align-items-center justify-content-between">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onRouting("/home", "home");
            }}
            className="navbar-brand"
          >
            <div className="logo-main">
              <div className="logo-normal">
                <img src={normalLogo} className="img-fluid" alt="logo" />
              </div>
              <div className="logo-mini">
                <img src={miniLogo} className="img-fluid" alt="logo mini" />
              </div>
            </div>
          </a>

          <button
            type="button"
            className="btn-close-sidebar d-lg-none"
            aria-label="Close sidebar"
            onClick={() => setIsMobileOpen(false)}
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <div className="sidebar-body pt-0 data-scrollbar pb-4">
          <div className="sidebar-list pb-4">
            <button
              type="button"
              className={
                activeStatus === "add_new_documents"
                  ? "nav-item active quick-create-btn my-2 "
                  : "nav-item quick-create-btn my-2"
              }
              aria-current={
                activeStatus === "add_new_documents" ? "page" : undefined
              }
              onClick={() =>
                onRouting("/add_new_documents", "add_new_documents")
              }
            >
              <i className="icon-plus-circle" />
              <span>ສ້າງເອກະສານໃໝ່</span>
            </button>

            <ul className="navbar-nav iq-main-menu" id="sidebar-menu">
              <NavItem
                route="home"
                label="ໜ້າຫຼັກ"
                icon={
                  <svg
                    width={20}
                    className="icon-30"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <NavItem
                route="documents"
                label="ຈັດການເອກະສານທົ່ວໄປ"
                icon={
                  <svg
                    className="icon-30"
                    width="32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.07996 6.6499V6.6599C7.64896 6.6599 7.29996 7.0099 7.29996 7.4399C7.29996 7.8699 7.64896 8.2199 8.07996 8.2199H11.069C11.5 8.2199 11.85 7.8699 11.85 7.4289C11.85 6.9999 11.5 6.6499 11.069 6.6499H8.07996ZM15.92 12.7399H8.07996C7.64896 12.7399 7.29996 12.3899 7.29996 11.9599C7.29996 11.5299 7.64896 11.1789 8.07996 11.1789H15.92C16.35 11.1789 16.7 11.5299 16.7 11.9599C16.7 12.3899 16.35 12.7399 15.92 12.7399ZM15.92 17.3099H8.07996C7.77996 17.3499 7.48996 17.1999 7.32996 16.9499C7.16996 16.6899 7.16996 16.3599 7.32996 16.1099C7.48996 15.8499 7.77996 15.7099 8.07996 15.7399H15.92C16.319 15.7799 16.62 16.1199 16.62 16.5299C16.62 16.9289 16.319 17.2699 15.92 17.3099Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <NavItem
                route="private_documents"
                label="ຈັດການເອກະສານສ່ວນຕົວ"
                icon={
                  <svg
                    className="icon-32"
                    width="32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M12.0865 22C11.9627 22 11.8388 21.9716 11.7271 21.9137L8.12599 20.0496C7.10415 19.5201 6.30481 18.9259 5.68063 18.2336C4.31449 16.7195 3.5544 14.776 3.54232 12.7599L3.50004 6.12426C3.495 5.35842 3.98931 4.67103 4.72826 4.41215L11.3405 2.10679C11.7331 1.96656 12.1711 1.9646 12.5707 2.09992L19.2081 4.32684C19.9511 4.57493 20.4535 5.25742 20.4575 6.02228L20.4998 12.6628C20.5129 14.676 19.779 16.6274 18.434 18.1581C17.8168 18.8602 17.0245 19.4632 16.0128 20.0025L12.4439 21.9088C12.3331 21.9686 12.2103 21.999 12.0865 22Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11.3194 14.3209C11.1261 14.3219 10.9328 14.2523 10.7838 14.1091L8.86695 12.2656C8.57097 11.9793 8.56795 11.5145 8.86091 11.2262C9.15387 10.9369 9.63207 10.934 9.92906 11.2193L11.3083 12.5451L14.6758 9.22479C14.9698 8.93552 15.448 8.93258 15.744 9.21793C16.041 9.50426 16.044 9.97004 15.751 10.2574L11.8519 14.1022C11.7049 14.2474 11.5127 14.3199 11.3194 14.3209Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <NavItem
                route="all_file"
                label="ໄຟລ໌ເອກະສານທັງໝົດ"
                icon={
                  <svg
                    className="icon-32"
                    width="32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.97398 11.3877H12.359C12.77 11.3877 13.104 11.0547 13.104 10.6437C13.104 10.2327 12.77 9.89868 12.359 9.89868H8.97398C8.56298 9.89868 8.22998 10.2327 8.22998 10.6437C8.22998 11.0547 8.56298 11.3877 8.97398 11.3877ZM8.97408 16.3819H14.4181C14.8291 16.3819 15.1631 16.0489 15.1631 15.6379C15.1631 15.2269 14.8291 14.8929 14.4181 14.8929H8.97408C8.56308 14.8929 8.23008 15.2269 8.23008 15.6379C8.23008 16.0489 8.56308 16.3819 8.97408 16.3819Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <li>
                <hr className="hr-horizontal" />
              </li>

              <li className="nav-item static-item">
                <span className="nav-link static-item disabled text-start">
                  <strong className="default-icon">
                    ການສົ່ງ ແລະ ຮັບເອກະສານ
                  </strong>
                </span>
              </li>

              <NavItem
                route="send"
                label="ສົ່ງເອກະສານ"
                icon={
                  <svg
                    className="icon-32"
                    width="32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M21.4274 2.5783C20.9274 2.0673 20.1874 1.8783 19.4974 2.0783L3.40742 6.7273C2.67942 6.9293 2.16342 7.5063 2.02442 8.2383C1.88242 8.9843 2.37842 9.9323 3.02642 10.3283L8.05742 13.4003C8.57342 13.7163 9.23942 13.6373 9.66642 13.2093L15.4274 7.4483C15.7174 7.1473 16.1974 7.1473 16.4874 7.4483C16.7774 7.7373 16.7774 8.2083 16.4874 8.5083L10.7164 14.2693C10.2884 14.6973 10.2084 15.3613 10.5234 15.8783L13.5974 20.9283C13.9574 21.5273 14.5774 21.8683 15.2574 21.8683C15.3374 21.8683 15.4274 21.8683 15.5074 21.8573C16.2874 21.7583 16.9074 21.2273 17.1374 20.4773L21.9074 4.5083C22.1174 3.8283 21.9274 3.0883 21.4274 2.5783Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <NavItem
                route="inbox"
                label="ກ່ອງຮັບເອກະສານທົ່ວໄປ"
                icon={
                  <svg
                    className="icon-32"
                    width="32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M22 15.94C22 18.73 19.76 20.99 16.97 21H16.96H7.05C4.27 21 2 18.75 2 15.96V15.95C2 15.95 2.006 11.524 2.014 9.298C2.015 8.88 2.495 8.646 2.822 8.906C5.198 10.791 9.447 14.228 9.5 14.273C10.21 14.842 11.11 15.163 12.03 15.163C12.95 15.163 13.85 14.842 14.56 14.262C14.613 14.227 18.767 10.893 21.179 8.977C21.507 8.716 21.989 8.95 21.99 9.367C22 11.576 22 15.94 22 15.94Z"
                      fill="currentColor"
                    />
                    <path
                      d="M21.4759 5.67351C20.6099 4.04151 18.9059 2.99951 17.0299 2.99951H7.04988C5.17388 2.99951 3.46988 4.04151 2.60388 5.67351C2.40988 6.03851 2.50188 6.49351 2.82488 6.75151L10.2499 12.6905C10.7699 13.1105 11.3999 13.3195 12.0299 13.3195C12.6799 13.3195 13.3099 13.1105 13.8299 12.6905L21.2549 6.75151C21.5779 6.49351 21.6699 6.03851 21.4759 5.67351Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <NavItem
                route="inbox_isPrivate"
                label="ກ່ອງຮັບເອກະສານສ່ວນຕົວ"
                icon={
                  <svg
                    className="icon-32"
                    width="32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M22 15.94C22 18.73 19.76 20.99 16.97 21H16.96H7.05C4.27 21 2 18.75 2 15.96V15.95C2 15.95 2.006 11.524 2.014 9.298C2.015 8.88 2.495 8.646 2.822 8.906C5.198 10.791 9.447 14.228 9.5 14.273C10.21 14.842 11.11 15.163 12.03 15.163C12.95 15.163 13.85 14.842 14.56 14.262C14.613 14.227 18.767 10.893 21.179 8.977C21.507 8.716 21.989 8.95 21.99 9.367C22 11.576 22 15.94 22 15.94Z"
                      fill="currentColor"
                    />
                    <path
                      d="M21.4759 5.67351C20.6099 4.04151 18.9059 2.99951 17.0299 2.99951H7.04988C5.17388 2.99951 3.46988 4.04151 2.60388 5.67351C2.40988 6.03851 2.50188 6.49351 2.82488 6.75151L10.2499 12.6905C10.7699 13.1105 11.3999 13.3195 12.0299 13.3195C12.6799 13.3195 13.3099 13.1105 13.8299 12.6905L21.2549 6.75151C21.5779 6.49351 21.6699 6.03851 21.4759 5.67351Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <NavItem
                route="document_group"
                label="ກຸ່ມເອກະສານ"
                icon={
                  <svg
                    width={32}
                    className="icon-32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.4"
                      d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />

              <li>
                <hr className="hr-horizontal" />
              </li>

              <li className="nav-item static-item">
                <span className="nav-link static-item disabled text-start">
                  <strong className="default-icon">ຈັດການຂໍ້ມູນທົ່ວໄປ</strong>
                </span>
              </li>

              <NavItem
                route="query_licent"
                label="ຈັດການລາຍເຊັນ"
                icon={
                  <i className="fa-solid fa-signature" aria-hidden="true" />
                }
              />

              <NavItem
                route="logger"
                label="ຈັດການຕູ້ເອກະສານ"
                icon={
                  <i className="fa-solid fa-door-closed" aria-hidden="true" />
                }
              />

              <NavItem
                route="folder"
                label="ຈັດການແຟ້ມເອກະສານ"
                icon={
                  <i className="fa-solid fa-folder-open" aria-hidden="true" />
                }
              />

              <NavItem
                route="type_documents"
                label="ຈັດການໝວດເອກະສານ"
                icon={
                  <svg
                    width={32}
                    className="icon-32"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M21.25 13.4764C20.429 13.4764 19.761 12.8145 19.761 12.001C19.761 11.1865 20.429 10.5246 21.25 10.5246C21.449 10.5246 21.64 10.4463 21.78 10.3076C21.921 10.1679 22 9.97864 22 9.78146L21.999 7.10415C21.999 4.84102 20.14 3 17.856 3H6.144C3.86 3 2.001 4.84102 2.001 7.10415L2 9.86766C2 10.0648 2.079 10.2541 2.22 10.3938C2.36 10.5325 2.551 10.6108 2.75 10.6108C3.599 10.6108 4.239 11.2083 4.239 12.001C4.239 12.8145 3.571 13.4764 2.75 13.4764C2.336 13.4764 2 13.8093 2 14.2195V16.8949C2 19.158 3.858 21 6.143 21H17.857C20.142 21 22 19.158 22 16.8949V14.2195C22 13.8093 21.664 13.4764 21.25 13.4764Z"
                      fill="currentColor"
                    />
                    <path
                      d="M15.4303 11.5887L14.2513 12.7367L14.5303 14.3597C14.5783 14.6407 14.4653 14.9177 14.2343 15.0837C14.0053 15.2517 13.7063 15.2727 13.4543 15.1387L11.9993 14.3737L10.5413 15.1397C10.4333 15.1967 10.3153 15.2267 10.1983 15.2267C10.0453 15.2267 9.89434 15.1787 9.76434 15.0847C9.53434 14.9177 9.42134 14.6407 9.46934 14.3597L9.74734 12.7367L8.56834 11.5887C8.36434 11.3907 8.29334 11.0997 8.38134 10.8287C8.47034 10.5587 8.70034 10.3667 8.98134 10.3267L10.6073 10.0897L11.3363 8.61268C11.4633 8.35868 11.7173 8.20068 11.9993 8.20068H12.0013C12.2843 8.20168 12.5383 8.35968 12.6633 8.61368L13.3923 10.0897L15.0213 10.3277C15.2993 10.3667 15.5293 10.5587 15.6173 10.8287C15.7063 11.0997 15.6353 11.3907 15.4303 11.5887Z"
                      fill="currentColor"
                    />
                  </svg>
                }
              />
            </ul>
          </div>
        </div>
        <div className="sidebar-footer" />
      </aside>
    </>
  );
}
